import { useQueryClient } from '@tanstack/react-query';

import {
	RU_CONFIGURATIONS,
} from '@constants/queryKeys';

export const useInvalidateRUConfiguration = () => {
	const queryClient = useQueryClient();

	const invalidateRuConfiguration = () => {
		return [
			queryClient.invalidateQueries([RU_CONFIGURATIONS]),
		];
	};

	return {
		invalidateRuConfiguration,
	};
};
